<template>
  <div>
    <el-button type="primary" @click="handleAdd()" size="small">新建</el-button>
    <div class="myCont">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="no" label="编号"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="{ row }">
            <span v-if="row.type === 1">公司级</span>
            <!-- <span v-if="row.type === 2">公司级</span> -->
            <span v-if="row.type === 3">车间级</span>
            <span v-if="row.type === 4">班组级</span>
            <span v-if="row.type === 5">员工级</span>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="上报人"></el-table-column>
        <el-table-column prop="gmtCreate" label="上报时间"></el-table-column>
        <el-table-column prop="departmentVo.name" label="状态">
          <template slot-scope="{ row }">
            <el-tag type="warning" v-if="row.status === 0">预审批</el-tag>
            <el-tag type="primary" v-if="row.status === 1">部门审批</el-tag>
            <el-tag type="success" v-if="row.status === 2">公司领导审批</el-tag>
            <el-tag type="error" v-if="row.status === 3">审批完成</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="gmtCreate" label="创建时间"></el-table-column> -->
        <el-table-column prop="oper" label="操作" width="280">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper caozuo">
              <el-link type="primary" @click="preview(scope.row)">预览</el-link><span class="line"> | </span>
              <el-link type="primary" @click="edit(scope.row)">编辑</el-link><span class="line"> | </span>
              <el-link type="warning" @click="examine(scope.row.id)">审批</el-link><span class="line" style="color: #e6a23c"> | </span>
              <el-link type="danger" @click="delmsg(scope.row)">删除</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="block" style="textAlign: right;marginTop: 15px">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="sizePage"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 审批的抽屉 -->
    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      :show-close="false"
      :before-close="handleClose">
      <div style="padding: 0 20px;">
        <el-steps :active="obj.status" direction="vertical" style="height: 350px">
          <el-step>
            <h4 slot="title">发起人</h4>
            <!-- <div slot="description" v-if="obj.status > 0"> -->
            <div slot="description">
              <div>{{ obj.gmtCreate }}</div>
              <div>{{ obj.repPersonEmpName }}</div>
              <div>发起审核</div>
              <div>{{ obj.repPersonExplain }}</div>
            </div>
          </el-step>
          <el-step>
            <h4 slot="title">部门审批</h4>
            <!-- <div slot="description" v-if="obj.status > 1"> -->
            <div slot="description">
              <div>{{ obj.depAuditTime }}</div>
              <div>{{ obj.depHeadName }}</div>
              <div v-if="obj.depAuditStatus === 0" style="color: #E6A23C">通过</div>
              <div v-if="obj.depAuditStatus === 1" style="color: red">不通过</div>
              <div>{{ obj.depHeadAudit }}</div>
            </div>
          </el-step>
          <el-step>
            <h4 slot="title">公司领导审批</h4>
            <!-- <div slot="description" v-if="obj.status > 2"> -->
            <div slot="description">
              <div>{{ obj.comAuditTime }}</div>
              <div>{{ obj.comLeaderName }}</div>
              <div v-if="obj.comAuditStatus === 0" style="color: #E6A23C">通过</div>
              <div v-if="obj.comAuditStatus === 1" style="color: red">不通过</div>
              <div>{{ obj.comLeaderAudit }}</div>
            </div>
          </el-step>
        </el-steps>
        <el-divider v-if="(obj.status > 0 || obj.userId == userId) && obj.status !== 3" />
        <el-form :model="form" label-width="90px" v-if="(obj.userId == userId && obj.status === 0) || (obj.depHeadUserId == userId && obj.status === 1)
          || (obj.comLeaderUserId == userId && obj.status === 2)">
          <el-form-item label="是否通过" v-if="obj.status !== 0">
            <el-radio-group v-model="form.pass" size="small">
              <el-radio-button :label="0">通过</el-radio-button>
              <el-radio-button :label="1">不通过</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审批意见">
            <el-input type="textarea" :rows="2" v-model="form.auditContent" />
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="examineSure">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getYpList, examineYp, examinInfo } from '@/api/processManager'
export default {
  data() {
    return {
      total: 0,
      sizePage: 10,
      currentPage: 1,
      tableData: [],
      drawerVisible: false,
      obj: { status: 1 },
      userId: '',
      form: {
        pass: 0
      }
    };
  },
  created() {
    // this.componentsMoudel.startGet('/researchvote/list_all?limit=1&curPage=1', {}, true).then(res => {
    //   console.log(res)
    //   this.tableData = res.body.data
    // })
    this.userId = localStorage.getItem('userId')
    this.$nextTick(() => {
      this.getList()
    })
  },
  methods: {
    handleSizeChange(val) {
      this.sizePage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList()
    },
    // 添加
    handleAdd() {
      this.$router.push({
        path: "addRiskAna",
      });
    },
    // 预览
    preview(val) {
      // console.log(val)
      this.$router.push({
        name: 'risknotice',
        query: {...val}
      })
    },
    // 获取列表
    getList() {
      const data = { limit: this.sizePage, curPage: this.currentPage }
      getYpList(data).then((res) => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    // 编辑
    edit(item) {
      this.$router.push({
        path: 'addRiskAna',
        query: {
          ...item
        }
      })
    },
    // 审批
    examine(id) {
      this.drawerVisible = true
      examinInfo(id).then(res => {
        this.obj = {...res.body.data}
      })
    },
    handleClose() {
      this.drawerVisible = false
      this.getList()
    },
    // 提交审核
    examineSure() {
      let id = this.obj.id
      examineYp({ ...this.form, id: id }).then(res => {
        this.examine(id)
        this.form = { pass: 0 }
      })
    },
    // 删除
    delmsg(item) {
      this.$confirm(`确定删除 "${item.name}"`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.componentsMoudel.startPost(`/researchvote/delete/${item.id}`, {}, true).then(res => {
          if(this.tableData.length <= 1 && this.currentPage > 1) {
            this.currentPage -= 1
          }
          this.getList()
          this.$message.success('删除成功')
        })
      })
    },
  },
};
</script>

<style scoped>
.box {
  width: 100%;
  /* height: 100%; */
  background-color: white;
  padding: 15px;
}
.head {
  width: calc(100% - 250px);
}
.addBtn {
  width: 100px;
  position: absolute;
  top: 15px;
  right: 20px;
}
.caozuo span {
  color: rgb(64,158,255)
}
.line {
  margin: 0 5px
}
</style>
